import { Plugin_getInstancefllmgjpjiqqy as Plugin_getInstance } from './WebSockets.mjs';
import { plugin3vxt624hnu3pv as plugin } from '../HttpClientPlugin.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder } from '../../request/HttpRequest.mjs';
import { HttpStatement3zxb33q8lku as HttpStatement } from '../../statement/HttpStatement.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { DefaultClientWebSocketSession1n8ok3lng45wy as DefaultClientWebSocketSession } from './ClientSessions.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { close1my1iwn6t9rqe as close } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketSession.mjs';
import { Key_instance1cmljiecd0y8y as Key_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/ContinuationInterceptor.mjs';
import { withContext3dkm8s4upl4ld as withContext } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { get_useEngineDispatcher3ja9ea3m8f657 as get_useEngineDispatcher } from '../../statement/DispatcherSwitching.nonJvm.mjs';
import { unwrapCancellationException1zvbmufui4i9c as unwrapCancellationException } from '../../utils/ExceptionUtils.nonJvm.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { Companion_getInstancetfg6b5k18hsf as Companion_getInstance } from '../../../../../../ktor-ktor-http/io/ktor/http/URLProtocol.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_webSocket__btxtwt(_this__u8e3s4, request, block, $completion) {
  plugin(_this__u8e3s4, Plugin_getInstance());
  // Inline function 'io.ktor.client.request.prepareRequest' call
  // Inline function 'kotlin.apply' call
  var this_0 = new (HttpRequestBuilder())();
  this_0.w5w(webSocket$lambda);
  request(this_0);
  // Inline function 'io.ktor.client.request.prepareRequest' call
  var session = new (HttpStatement())(this_0, _this__u8e3s4);
  $l$block: {
    // Inline function 'io.ktor.client.statement.HttpStatement.body' call
    $l$block_0: {
      // Inline function 'io.ktor.client.plugins.unwrapRequestTimeoutException' call
      try {
        var tmp = session.z5w($completion);
        if (tmp === get_COROUTINE_SUSPENDED())
          tmp = yield tmp;
        var response = tmp;
        var tmp_0;
        try {
          if (get_useEngineDispatcher()) {
            var tmp_1 = ensureNotNull(response.ew().hd(Key_instance));
            var tmp_2 = withContext(tmp_1, webSocket$slambda_0(response, block), $completion);
            if (tmp_2 === get_COROUTINE_SUSPENDED())
              tmp_2 = yield tmp_2;
          } else {
            // Inline function 'io.ktor.client.call.body' call
            var tmp_3 = response.t5i();
            // Inline function 'io.ktor.util.reflect.typeInfo' call
            var tmp_4 = getKClass(DefaultClientWebSocketSession());
            // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
            var tmp_5;
            try {
              tmp_5 = createKType(getKClass(DefaultClientWebSocketSession()), arrayOf([]), false);
            } catch ($p) {
              var tmp_6;
              if ($p instanceof Error) {
                var _unused_var__etf5q3 = $p;
                tmp_6 = null;
              } else {
                throw $p;
              }
              tmp_5 = tmp_6;
            }
            var tmp$ret$4 = tmp_5;
            var tmp$ret$5 = new (TypeInfo())(tmp_4, tmp$ret$4);
            var tmp_7 = tmp_3.q5i(tmp$ret$5, $completion);
            if (tmp_7 === get_COROUTINE_SUSPENDED())
              tmp_7 = yield tmp_7;
            var tmp_8 = tmp_7;
            var result = tmp_8 instanceof DefaultClientWebSocketSession() ? tmp_8 : THROW_CCE();
            try {
              var tmp_9 = block(result, $completion);
              if (tmp_9 === get_COROUTINE_SUSPENDED())
                tmp_9 = yield tmp_9;
            }finally {
              var tmp_10 = close(result, VOID, $completion);
              if (tmp_10 === get_COROUTINE_SUSPENDED())
                tmp_10 = yield tmp_10;
              result.f5a().t1b();
            }
          }
          break $l$block;
        }finally {
          var tmp_11 = session.a5x(response, $completion);
          if (tmp_11 === get_COROUTINE_SUSPENDED())
            tmp_11 = yield tmp_11;
        }
      } catch ($p) {
        if ($p instanceof CancellationException()) {
          var cause = $p;
          throw unwrapCancellationException(cause);
        } else {
          throw $p;
        }
      }
    }
  }
  return Unit_instance;
}
function webSocket(_this__u8e3s4, request, block, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_webSocket__btxtwt.bind(VOID, _this__u8e3s4, request, block), $completion);
}
function webSocket$lambda($this$url, it) {
  $this$url.a55(Companion_getInstance().d55_1);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8($this, $this$withContext, $completion) {
  // Inline function 'io.ktor.client.call.body' call
  var tmp = $this.b5x_1.t5i();
  // Inline function 'io.ktor.util.reflect.typeInfo' call
  var tmp_0 = getKClass(DefaultClientWebSocketSession());
  // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
  var tmp_1;
  try {
    tmp_1 = createKType(getKClass(DefaultClientWebSocketSession()), arrayOf([]), false);
  } catch ($p) {
    var tmp_2;
    if ($p instanceof Error) {
      var _unused_var__etf5q3 = $p;
      tmp_2 = null;
    } else {
      throw $p;
    }
    tmp_1 = tmp_2;
  }
  var tmp$ret$0 = tmp_1;
  var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp$ret$0);
  var tmp_3 = tmp.q5i(tmp$ret$1, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp_4 = tmp_3;
  var result = tmp_4 instanceof DefaultClientWebSocketSession() ? tmp_4 : THROW_CCE();
  try {
    var tmp_5 = $this.c5x_1(result, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
  }finally {
    var tmp_6 = close(result, VOID, $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
    result.f5a().t1b();
  }
  return Unit_instance;
}
var webSocket$slambdaClass;
function webSocket$slambda() {
  if (webSocket$slambdaClass === VOID) {
    class $ {
      constructor($response, $block) {
        this.b5x_1 = $response;
        this.c5x_1 = $block;
      }
      c1g($this$withContext, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$withContext), $completion);
      }
      ud(p1, $completion) {
        return this.c1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    webSocket$slambdaClass = $;
  }
  return webSocket$slambdaClass;
}
function webSocket$slambda_0($response, $block) {
  var i = new (webSocket$slambda())($response, $block);
  var l = ($this$withContext, $completion) => i.c1g($this$withContext, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  webSocket as webSocket1c0mdzi4rb3bo,
};
//endregion

//# sourceMappingURL=builders.mjs.map
